module.exports = __webpack_public_path__ + "static/img/lexus.8a62522.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wechat/lexus.png
// module id = Aj0w
// module chunks = 44